<template>
  <div class="animated fadeIn" id="lista-projetos">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-notebook"></i> Lista de Projetos
      </div>
      <div class="card-body">
        <datatable-panel :per-page="30"
          :url="`${$root.url}/projeto?token=${$root.usuario('access_token')}`"
          :fields="fields"
          :sortField="fields[0]"
          ref="datatable"
          :searchBar="searchBar">
        </datatable-panel>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #lista-projetos {
    .details {
      width: 15px;
      text-align: center;
    }

    .search-bar {
      & .container-fluid {
        padding-left: 0;

        & button {
          margin-left: 15px;
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue';
  import DatatablePanel from 'metawesome-datatable';
  import CustomActions from './CustomActions';
  import SearchBar from './SearchBar';

  import Uteis from '@/mixins/utils.js';
  Vue.component('custom-actions', CustomActions);

  export default {
    components: {
      DatatablePanel,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        searchBar: SearchBar,
        fields: [
          { name: 'name', sortField: 'name', title: 'Nome', callback: this.formatarNome },
          { name: 'centro_custo_sap', sortField: 'centro_custo_sap', title: 'Código Centro de Custo' },
          { name: 'competencia', sortField: 'competencia', title: 'Competência' },
          { name: '__component:custom-actions', title: 'GitLab', titleClass: 'details', dataClass: 'details' },
        ],
      };
    },
  }
</script>
